module.exports = __webpack_public_path__ + "img/c04_unitcaravan_Normal_ua.4673cfca.webp";